import React from "react";
import { Button } from "antd";

export const BtnPrincipal = ({ texto,  onClick, estilo }) => {
  return (
    <Button
      onClick={onClick}
      style={estilo} 
    >
      {texto}
    </Button>
  );
};

